export default (theme) => ({
  root: {},
  gridItem: {
    padding: theme.spacing(0),
  },
  map: {
    minWidth: '0',
    minHeight: 'calc(-195px + 100vh)',
  },
  legend: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  topSpacer: { height: '60px' },
  tableSettingsSection: {
    justifyContent: 'space-between',
    display: 'flex',
  },
  tableSettings: {
    alignItems: 'end',
    alignSelf: 'flex-end',
  },
  templateTable: {
    maxHeight: 'calc(-195px + 100vh)',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    margin: theme.spacing(1),
  }
});
